'use strict';

require('../customers/CompanyCustomersService.js');

TaskQueryUserDirective.$inject = ['CompanyUserService', '$stateParams'];
function TaskQueryUserDirective(CompanyUserService, $stateParams) {
  return {
    restrict: 'A',
    require: 'ngModel',
    replace: true,
    scope: {
      saveTask: "&",
      editDisabled: "="
    },
    link: function(scope, elem, attrs, ngModel) {
      ngModel.$render = function() {
        scope.items = ngModel.$modelValue;
      };

      scope.updateNonAssignees = function(filter) {
        CompanyUserService.query({companyId: $stateParams.companyId, q: filter, type: 'DEFAULT', limit: 6}).$promise.then(function(users) {
          if (attrs.type && attrs.type === 'assignee') {
            return users.filter(function(item) {
              return !scope.items.some(function(assignee) {
                return item.id === assignee.id;
              });
            });
          }
          return users.filter(function(item) {
            if (scope.items === null || typeof scope.items === 'undefined') {
              return true;
            } else {
              return item.id !== scope.items.id;
            }
          });
          
        }).then(function(nonAssignees) {
          scope.nonAssignees = nonAssignees;
        });
      };

      scope.addAssignees = function(assignee) {
        if (attrs.type && attrs.type === 'assignee') {
          scope.items.push(assignee);
        } else {
          scope.items = assignee;
        }
        ngModel.$setViewValue(scope.items);
        if (typeof scope.saveTask === 'function') {
          scope.saveTask();
        }
        scope.nonAssignees.splice(scope.nonAssignees.indexOf(assignee), 1);
        if (attrs.type && attrs.type === 'assignee') {
          angular.element('#filterAssignees').val('');
        } else {
          angular.element('#filterManager').val('');
        }
      };

      scope.removeAssignee = function(assignee) {
        if (attrs.type && attrs.type === 'assignee') {
          scope.items.splice(scope.items.indexOf(assignee), 1);
        } else {
          scope.items = null;
        }
        ngModel.$setViewValue(scope.items);
        if (typeof scope.saveTask === 'function') {
          scope.saveTask();
        }
      };
    },
    templateUrl: function (element, attrs) {
      if (attrs.type && attrs.type === 'assignee') {
          return 'partials/company/tasks/assignees-directive.html';
      } else {
        return 'partials/company/tasks/manager-directive.html';
      }
    }
  };
}

angular.module("dokiv")
  .directive("taskQueryUser", TaskQueryUserDirective);

TaskQueryCustomerDirective.$inject = ['CompanyCustomersService', '$stateParams'];
function TaskQueryCustomerDirective(CompanyCustomersService, $stateParams) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: {
      saveTask: "&"
    },
    replace: true,
    link: function(scope, elem, attrs, ngModel) {
      ngModel.$render = function() {
        scope.currentCustomer = ngModel.$modelValue;
      };

      scope.queryCustomers = function(query) {
        return CompanyCustomersService.query({
          companyId: $stateParams.companyId,
          q: query,
          limit: 10
        }).$promise.then(function(customers) {
          if (scope.currentCustomer) {
            return customers.filter(function(c) {
              return c.id !== scope.currentCustomer.id;
            }); 
          }
          return customers;
          
        });
      };

      scope.addConnectedCustomer = function(c) {
        scope.currentCustomer = angular.copy(c);
        ngModel.$setViewValue(c);
        if (typeof scope.saveTask === 'function') {
          scope.saveTask();
        }
      };
    },
    templateUrl: 'partials/company/tasks/connected-customer-directive.html'
  };
}

angular.module("dokiv")
    .directive("taskQueryCustomer", TaskQueryCustomerDirective);

CompanyTasksCtrl.$inject = ['$scope'];
function CompanyTasksCtrl($scope) {
  $scope.onSelectEvent = function(task) {
    $scope.showTaskDetailModal(task);
  };

  $scope.expiredColor = "#f26a5d";
  $scope.importanceColors = [
    {
      'type': 'LOW',
      'color': '#27b96b'
    },
    {
      'type': 'NORMAL',
      'color': '#27c2eb'
    },
    {
      'type': 'HIGH',
      'color': '#f29a25'
    }
  ];

  $scope.visibilityColors = [
    {
      'public': true,
      'color': '#23a45f'
    },
    {
      'public': false,
      'color': '#27c2eb'
    },
  ];
}


angular.module('dokiv')
  .controller('CompanyTasksCtrl', CompanyTasksCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/tasks/CompanyTasksCtrl.js
// module id = 421
// module chunks = 0